import * as DropdownStyles from './Dropdown.styles'

export { default as Dropdown } from './Dropdown'
export type { DropdownPlacement, DropdownPlacementStrategy } from './Dropdown.types'
export const StyledDropdown = DropdownStyles
